import angular from 'angular';
import full from './self-video-frame-full/self-video-frame-full';
import mini from './self-video-frame-mini/self-video-frame-mini';
import template from './self-video-frame.html';
import * as call from '../../../modules/call';
import * as devices from '../../../modules/devices';
class SelfVideoFrameController {
    constructor(VideoProviderFactory, $ngRedux) {
        this.VideoProviderFactory = VideoProviderFactory;
        this.$ngRedux = $ngRedux;
        this.unsubscribeFromStore = this.$ngRedux.connect(this.mapStateToThis.bind(this))(this);
        this.VideoProviderFactory.decorateScope(this);
        this.videoPublisherId =
            this.VideoProviderFactory.activeProvider.localVideoPublisherId;
    }
    mapStateToThis(state) {
        return {
            hasCameraAccess: devices.selectors.hasCameraAccess(state),
            hasSelfPublisherError: call.selectors.hasSelfPublisherError(state),
            isSelfPreviewLoading: call.selectors.isSelfPreviewLoading(state),
            isPreviewsListVisible: call.selectors.selectPreviewsListVisibility(state),
        };
    }
    get isMiniFrameVisible() {
        return this.isPreviewsListVisible && (!this.isFull || this.isInGroupCall);
    }
    $onDestroy() {
        this.unsubscribeFromStore();
    }
}
const component = {
    template,
    bindings: {
        isVideoDisabled: '<',
        onSelect: '&',
        isInGroupCall: '<',
        isFull: '<',
        isGalleryView: '<',
        disabled: '<',
        isPinned: '<',
        avatarPicture: '<',
        cameraOff: '<',
        patientModalOpen: '<',
        isPatient: '<',
        isCheckInPhotoCaptureEnabled: '<',
    },
    controller: SelfVideoFrameController,
};
export default angular
    .module('doxy.videoChat.callFrames.selfVideoFrameComponent', [full, mini])
    .component('selfVideoFrame', component).name;
